const FilterChipMixin = {
  props: {
    filter: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    }
  },

  template: `
    <div class="chip">
      <span class="tip">{{ slicedTitle }}:</span>
      <span class="text-ellipsis">{{ text_value }}</span>
      <i v-if='removable' class="slp-times" @click='removeHandler'></i>
    </div>
  `,

  computed: {
    text_value: function() {
      return this.filter.value;
    },

    slicedTitle: function() {
      var sliced_value;

      sliced_value = this.filter.field.title.slice(0, 5);
      if (sliced_value !== this.filter.field.title) {
        sliced_value = `${sliced_value}...`;
      }
      return sliced_value;
    }
  },

  methods: {
    removeHandler: function() {
      this.$emit('remove', this.filter);
    }
  }
};

export default FilterChipMixin;
